
import { computed, defineComponent } from 'vue';
import { IUploadInfo } from '@/composables/UseUpload';

export default defineComponent({
  emits: ['cancel-upload'],
  props: {
    uploadInfo:
      {
        type: Object as () => IUploadInfo, required: true,
      },
  },
  setup(props, { emit }) {
    const total = computed(() => `Total: ${props.uploadInfo.counter}/${props.uploadInfo.total}`);
    const errors = computed(() => `Errors: ${props.uploadInfo.error}`);
    const percentage = computed(() => ((props.uploadInfo.totalBytesUploaded / props.uploadInfo.totalBytesSize) * 100).toFixed(2) || 0);
    // eslint-disable-next-line max-len
    const upload = computed(() => `${(props.uploadInfo.totalBytesUploaded / 1048576).toFixed(2)} Mb / ${(props.uploadInfo.totalBytesSize / 1048576).toFixed(2)} Mb`);
    const uploadPercent = computed(() => `${percentage.value} %`);

    function cancelUpload() {
      emit('cancel-upload');
    }
    return {
      total,
      errors,
      upload,
      uploadPercent,
      cancelUpload,
    };
  },
});
